import React from "react";
import { width } from "styled-system";
import Svg from "../Svg";


import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
   <img style={{width:'170px'}} src="https://bafybeiew3bq5vmo6t47kjn422gzmigudejujsvjzchy3tyl2jge52pwe6e.ipfs.w3s.link/logo.png"/>
  );
};

export default Icon;
